<script>
  import './style.css';
  import { navigate } from "svelte-routing";
  import Cookies from 'js-cookie';

  import Copyright from 'src/components/copyright/copyright.svelte';

  document.body.classList.remove("sb-nav-fixed");
  document.body.classList.add("bg-primary");

  export let conn;

  const token = Cookies.get('token');

  const join = () => {
    conn.send(JSON.stringify({
      action: 'join',
      name: document.getElementById('inputName').value,
      token: token,
      roomId: document.getElementById('inputRoomCode').value
    }));
  }

  const create = () => {
    conn.send(JSON.stringify({
      action: 'create',
      name: document.getElementById('inputNameCreate').value,
      token: token
    }));
  }
</script>

<div id="layoutAuthentication">
    <div id="layoutAuthentication_content">
        <main>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-5">
                        <div class="card shadow-lg border-0 rounded-lg mt-5">
                            <div class="card-header"><h3 class="text-center font-weight-light my-4">Join A Room</h3></div>
                            <div class="card-body">
                                <form>
                                    <div class="form-floating mb-3">
                                        <input class="form-control" id="inputName" type="text" placeholder="Name" />
                                        <label for="inputName">Name</label>
                                    </div>
                                    <div class="form-floating mb-3">
                                        <input class="form-control" id="inputRoomCode" type="text" placeholder="Room Code" />
                                        <label for="inputRoomCode">Room Code</label>
                                    </div>
                                </form>
                            </div>
                            <div class="card-footer text-center py-3">
                              <a class="btn btn-block btn-primary" href="#!" on:click={() => {join()}}>Join</a>
                            </div>
                        </div>
                        <div class="card shadow-lg border-0 rounded-lg mt-5">
                            <div class="card-header">
                              <h3 class="text-center font-weight-light my-4">Create A Room</h3>
                            </div>
                            <div class="card-body">
                                <form>
                                    <div class="form-floating mb-3">
                                        <input class="form-control" id="inputNameCreate" type="text" placeholder="Name" />
                                        <label for="inputNameCreate">Name</label>
                                    </div>
                                </form>
                            </div>
                            <div class="card-footer text-center py-3">
                              <a class="btn btn-block btn-primary" href="#!" on:click={() => {create()}}>Create</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
    <Copyright />
</div>
